//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return{
      tableData: [],
      bill:{},
      invSub: false,
      from: {
        source: 0,
        money:'',
        phone: '',
        endTime: '',
        remark: '',
      },
      pageNo:1, 
      total:10,
      provincialList:[
        { value: 0, text: '系统返现'}
      ],
      addBackUserList: []
    }
  },
    mounted(){
    this.info()
  },
  methods:{
    info(val = 1){

      let data = {
        pageNo: val,
        pageSize: 10,
        cashBackId: this.$route.query.cashBackId
      }
      this.$axios.post('/mtea/cashBack/cashBackItemList', data).then(res => {
        this.tableData = res.item.records
        this.bill = res.info
        this.total = res.item.total
      }).catch(() => {
        this.tableData = []
        this.total = 0
      })
    },
    alterbackMoney(){
      this.invSub = true
      this.from.source = 0
      this.from.money = this.bill.totalMoney/100
      this.from.phone = this.bill.sysStaffId
      this.from.endTime = this.bill.pastTime
      this.from.remark = this.bill.cashDesc
      this.from.backMoney = this.bill.backMoney/100

      let data = {
        sysShopId: this.$route.query.shopId,
      }
      this.$axios.post('/mtea/cashBack/getStaffLists', data).then(res => {
         this.addBackUserList = []
        res.forEach(e => {
          this.addBackUserList.push({value: e.staffId, text:`${e.userName}(${e.userPhone})`})
        });
      })

    },
    headerStyle(){
      let style = {}
      style.color = '#000'
      style['font-weight'] = 600
      style['text-align'] = 'center'
      style['background-color'] = '#f1f1f1'
      return style
    },
    rowStyle(){
      let style = {}
      style['text-align'] = 'center'
      style['font-size'] = '12px'
      return style
    },
    endTimeChange(val){
      if(new Date(val.value).getTime() < new Date().getTime()){
        this.$message.error('有效期不能为已过去时间！')
        this.from.endTime = ''
      }
    },
    addCallBack(){
      if(this.from.money === ''){
        this.$message({
            message: '请输入返现总金额',
        });
        return
      }else if( this.from.money <= 0 ){
        this.$message.error( '返现总金额不能小于等于0！' )
        return
      }else if( this.from.money < this.from.backMoney ){
        this.$message.error('返现总金额不能小于已返现金额！')
        return
      }else if (isNaN(Number(this.from.money)) ){
        this.$message.error('返现总金额格式错误！')
        this.from.money = ''
        return
      }else if( this.from.phone === '' ){
        this.$message.error('请输入返现账号！')
        return
      }else if( this.from.endTime === '' ){
        this.$message.error('请选择有效期！')
        return
      }
      let data = {
        pastTime: this.from.endTime,
        sysShopId: this.$route.query.shopId,
        cashBackId: this.$route.query.cashBackId,
        sysStaffId:this.from.phone,
        totalMoney: this.from.money * 100,
        type: 0,
      }
      if(this.from.remark) data.desc = this.from.remark
      this.$axios.post('/mtea/cashBack/modifyCashBack', data).then(res => {
        this.$message({
            message: '保存成功',
            type: 'success'
        });
        this.info()
        this.invSub = false
        
      })
    }
  }
}
